<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitNewFranchise">
      <div class="form-group">
        <label for="newFranchise_name">{{$t('views.franchise.franchise_name')}}</label>
        <input
            id="newFranchise_name"
            v-model="newFranchise.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && $v.newFranchise.name.$error }"
        />
        <div v-if="submitted && $v.newFranchise.name.$error" class="invalid-feedback">
          <span v-if="!$v.newFranchise.name.required">{{$t('validatePhrases.requiredField')}}</span>
          <span v-if="!$v.newFranchise.name.minLength">
                        {{$t('validatePhrases.minLength')}}: 3
                      </span>
          <span v-if="!$v.newFranchise.name.maxLength">
                        {{$t('validatePhrases.maxLength')}}: 30
                      </span>
        </div>
      </div>
      <button class="btn btn-sm btn-success" type="submit">{{$t('popularWords.add')}}</button>
    </form>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('views.franchise.franchise_list')}}</h4>

        <div class="row mt-3">
          <div class="col-12">
            <table class="table table-hover mb-0">
              <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <th>
                  <div>{{item.franchise_name}}</div>
                </th>
                <th>
                  <div class="button-items text-right">
                    <div @click="deleteFranchise(item.id)" class="btn btn-sm btn-danger">{{$t('popularWords.delete')}}</div>
                  </div>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <popup
        :closeButton="deletePopup.closeButton"
        :actionButton="deletePopup.actionButton"
        :actionClass="deletePopup.actionClass"
        :show="deletePopup.show"
        @closePopup="closeDeletePopup"
        @actionPopup="deletePopupSubmit"
    >
      <div slot="header">{{$t('views.franchise.delete_franchise')}}</div>
      <div slot="body">
        {{$t('views.franchise.delete_franchise_text')}}
      </div>
    </popup>

  </div>
</template>

<script>

import {maxLength, minLength, required} from "vuelidate/lib/validators";
import axios from "axios";
import Popup from "@/components/Popup";

export default {
  name: "Franchise",
  components: {Popup},
  data(){
    return {
      list: [],
      newFranchise: {
        name: ''
      },
      submitted: false,
      deletedId: 0,
      deletePopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.confirm'),
        actionClass: "btn-success"
      },
    }
  },
  props: {

  },
  watch: {
    list: function(val){
      this.$emit('updateList', val);
    }
  },
  computed: {

  },
  validations: {
    newFranchise: {
      name: { required, minLength: minLength(3), maxLength: maxLength(250) },
    }
  },
  methods: {
    submitNewFranchise(){
      this.submitted = true;
      // stop here if form is invalid
      this.$v.newFranchise.$touch();
      if(!this.$v.newFranchise.$invalid){
        let formData = new FormData();
        formData.append("name", this.newFranchise.name);

        axios
            .post(`/v1/franchise/add`, formData)
            .then(resp => {
              this.list = resp.data;
              this.$store.dispatch("addNotification", {
                text: this.$t('popularWords.successfully'),
                time: 2,
                color: "success"
              });
            })
            .catch(err => {
              this.$store.dispatch("addNotification", {
                text: err.response.data.message,
                time: 6,
                color: "danger"
              });
            });
      }
    },
    deleteFranchise(id){
      this.deletedId = id;
      this.deletePopup.show = true;
    },
    closeDeletePopup(){
      this.deletePopup.show = false;
    },
    deletePopupSubmit(){
      let formData = new FormData();
      formData.append("id", this.deletedId);

      axios
          .post(`/v1/franchise/delete`, formData)
          .then(() => {
            this.$store.dispatch("addNotification", {
              text: this.$t('popularWords.deleted'),
              time: 2,
              color: "success"
            });
            this.getAll();
            this.closeDeletePopup();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    getAll(){
      axios
          .get(`/v1/franchise/get-all`)
          .then(resp => {
            this.list = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    }
  },
  created() {
    this.getAll();
  }

};
</script>

<style scoped lang="css">

</style>
